// Comprehensive list of measuring units used by Indian small businesses.
// Format: "Display Name (CODE)"
export const MEASURING_UNITS = [
  "Aaaaaaaaaaa (G NEX)", "Aana (ANA)", "Accessories (ACS)", "Acre (AC)", "Adult (ADL)",
  "Ampoule (AMP)", "Bags (BAG)", "Bale (BAL)", "Balls (BALL)", "Barni (BAR)",
  "Barrel (BRL)", "Batch (BTH)", "Billions Of Units (BOU)", "Blister (BLISTER)",
  "Bolus (BOLUS)", "Book (BK)", "Bora (BOR)", "Bottles (BTL)", "Box (BOX)",
  "Brass (BRASS)", "Brick (BRICK)", "Buckets (BCK)", "Buckles (BKL)", "Bunches (BUN)",
  "Bundles (BDL)", "Butts (BTS)", "Cable (CBL)", "Cans (CAN)", "Cap (CAP)",
  "Capsules (CPS)", "Carat (CT)", "Carats (CTS)", "Card (CARD)", "Cartons (CTN)",
  "Cartridge (CART)", "Case (CASE)", "Centimeter (CMS)", "Cents (CNT)", "Ch (CHAIN)",
  "Chain (CHN)", "Child (CLD)", "Choka (CHOKA)", "Chudi (CHUDI)", "Cloth (CLT)",
  "Coil (COIL)", "Cone (CN)", "Container (CONT)", "Copy (COPY)", "Cotton (COTT)",
  "Course (COURSE)", "Crate (CRT)", "Cream (CRM)", "Cubic Centimeter (CCM)",
  "Cubic Feet (CUFT)", "Cubic Feet Per Minute (CFM)", "Cubic Foot (CFT)",
  "Cubic Meter (CBM)", "Cubic Meters (CUM)", "Cup (CUP)", "Cv (CV)", "Daily (DAILY)",
  "Dangler (DANGLER)", "Days (DAY)", "Daze (DEZ)", "Decimeter (DMTR)", "Dozen (DOZ)",
  "Drop (DROP)", "Drum (DRM)", "Duty (DUTY)", "Ea (EA)", "Each (EACH)", "Feet (FT)",
  "Feet Square (FT2)", "Finger (FNGR)", "Fit (FIT)", "Flat (FLT)", "Fold (FLD)",
  "Fortnight (FN)", "Free (FREE)", "Fts (FTS)", "Full Plate (FP)", "Gel (GEL)",
  "Glasses (GLS)", "Grams (GMS)", "Great Gross (GGR)", "Gross (GRS)",
  "Gross Yards (GYD)", "Half (HF)", "Half Plate (H.P.)", "Hanger (HEGAR)",
  "Hangers (HANGER)", "Hectare (HA)", "Helmet (HMT)", "Horsepower (HP)", "Hours (HRS)",
  "Hundreds (HDS)", "Ijn (INJECTION)", "Inch Dia (ID)", "Inch-meter (IM)", "Inches (IN)",
  "Inj (INJECTION)", "Insertion (INS)", "Item Id (ITEM ID)", "Jars (JAR)", "Jhal (JL)",
  "Jhola (JO)", "Jhola Jhal (JHL)", "Jhudi (JHD)", "Job (JOB)", "Katta (KT)",
  "Kilograms (KGS)", "Kiloliter (KLR)", "Kilometre (KME)", "Kilometres (KMS)",
  "Kilovolt-amp (KVA)", "Kilowatt (KW)", "Kit (KIT)", "Km (KM)", "Ladi (LAD)",
  "Length (LENG)", "Libra Pondo (LBS)", "Line (LNE)", "Litre (LTR)", "Lot (LOT)",
  "Lump Sum (LS)", "M (MILLE)", "Man-days (MAN-DAY)", "Marakkal (MK)", "Mark (MRK)",
  "Mbps (MBPS)", "Megawatt (MW)", "Meters (MTR)",
  "Metric Million British Thermal Unit (MMBTU)", "Metric Ton (MTON)",
  "Metric, Ton (MTS)", "Microgram (\u03BCG)", "Mille (M)", "Millicoulomb (M/C)",
  "Milligram (MLG)", "Millilitre (MLT)", "Millimeter (MM)", "Minutes (MINS)",
  "Month (UOM)", "Months (MON)", "Mora (MORA)", "Nights (NIGHT)", "Non. (NON)",
  "None (NONE)", "Numbers (NOS)", "Ointment (OINT)", "Others (OTH)", "Outer (OR)",
  "Package (PKG)", "Packet (PACK)", "Packets (PKT)", "Packs (PAC)", "Pad (PAD)",
  "Pads (PADS)", "Pages (PAGE)", "Pair (PAIR)", "Pairs (PRS)", "Panel (PNL)",
  "Part (PART)", "Patta (PATTA)", "Patti (PTI)", "Pax (PAX)", "Per (PER)",
  "Per Day (/DAY)", "Per Metric Ton (PMT)", "Per Trainer (PER TRAINER)",
  "Per Watt Peak (PWP)", "Persons (PERSON)", "Peti (PET)", "Phile (PHILE)",
  "Pieces (PCS)", "Pipe (PIPE)", "Plates (PLT)", "Pocket (PCKT)", "Point (PT)",
  "Portion (PRT)", "Pouch (POCH)", "Pound (POUND)", "Puda (PD)", "Quad (QUAD)",
  "Quantity (QTY)", "Quarter (QT)", "Quintal (QTL)", "Ratti (RTI)", "Ream (REAM)",
  "Reel (REEL)", "Respules (RESP)", "Rim (RIM)", "Rolls (ROL)", "Room (ROOM)",
  "Running Foot (RFT)", "Running Meter (RMT)", "Rupees (RS)", "Sachet (SAC)",
  "Seconds (SEC)", "Semester (SEM)", "Service (SERVICE)", "Session (SSN)", "Sets (SET)",
  "Sheet (SHEET)", "Skins (SKINS)", "Slants (SLT)", "Sleves (SLEVES)", "Spindles (SPLS)",
  "Spray (SPRAY)", "Square Centimeters (SQCM)", "Square Feet (SQF)", "Square Gaj (GAJ)",
  "Square Gaz (GAZ)", "Square Inches (SQIN)", "Square Kilometer (SQ KM)",
  "Square Meters (SQM)", "Square Yards (SQY)", "Srm (SARAM)", "Std Pouch (ST POUCH)",
  "Stickers (STICKER)", "Stone (STONE)", "Strips (STRP)", "Syrup (SYRP)",
  "Tablets (TBS)", "Ten Gross (TGM)", "Test (TEST)", "Than (TN)", "Thousands (THD)",
  "Ticket (TKT)", "Tin (TIN)", "Tonnes (TON)", "Trays (TRY)", "Trolly (TRLY)",
  "Trp (TRIP)", "Truck (TRK)", "Tubes (TUB)", "Units (UNT)", "Us Gallons (UGS)",
  "Vials (VIAL)", "Watt (W)", "Weeks (WEEK)", "Yards (YDS)", "Years (YRS)",
];
